module.exports = __webpack_public_path__ + "kentico.png?e94d02c19b1490decff01aee58210db9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partners/kentico.png
// module id = 185
// module chunks = 0